import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-card-status-exceeded-tries',
    templateUrl: './card-status-exceeded-tries.component.html',
    styleUrls: ['./card-status-exceeded-tries.component.css'],
    standalone: false
})
export class CardStatusExceededTriesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
